<template lang="pug">
  .DrawerFooter
    .DrawerFooter_background
    transition(appear name="reverse" mode="out-in")
      p.DrawerFooter_count(:key="numItems") {{ numItems.length < 10 ? numItems : '0' + numItems }}
    transition(appear name="reverse" mode="out-in")
      p.DrawerFooter_value(:key="numItems") {{ $tc('drawer.footer.samples', numItems) }}
</template>

<script>

export default {
  props: ['numItems']
}

</script>

<style lang="stylus" scoped>

.DrawerFooter

  width 100%
  position relative
  align-items center
  display flex
  flex-direction row
  justify-content flex-end
  padding 20px
  box-sizing border-box
  text-align right
  color $beige

  @media $mq_m
    padding 30px 40px

  @media $mq_l
    padding 30px 50px
    min-height 110px

  &_value

    text-transform uppercase
    letter-spacing: 0.15em;

    @media $mq_s_only
      font-size: 10px;
      letter-spacing: 0.1em;

  &_count

    font-weight 600
    font-size: 30px;
    margin-right 20px
    letter-spacing: 0.05em;

    @media $mq_m
      font-size: 40px;

    @media $mq_s_only
      font-size: 21px;
      margin-right 10px

  &_background

    background-image url(/img/backgrounds/relief_background.jpg)
    background-size cover
    height 100%
    width 100%
    top 0px
    left 0px
    opacity 0.3
    position absolute

</style>
